import {SurveyMcqOptionAction} from './survey-mcq-option-action.enum';
/**
 * Created by tbhasme on 08-10-2017.
 */
export class SurveyMcqOption {
  id: number;
  optionText: string;
  action: SurveyMcqOptionAction = SurveyMcqOptionAction.ADD;
  sequence: number;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/survey/survey-mcq-option.model.ts